export * from './project.api';
export * from './vendor.api';
export * from './app.api';
export * from './authentication.api';
export * from './admin.account.api';
export * from './account.api';
export * from './notifications.api';
export * from './reports.api';
export * from './scraper.api';
export * from './gcCertify.api';

export namespace API {

  export type Response<T> = {
    data: T;
    message?: string;
  }

  export type General<T> = {
    status: number;
    body: T
  }

  export type Data<T> = {
    status: number;
    body: {
      message: string;
      data: T;
    }
  }

  export type Paginate = {
    skip?: number;
    take?: number;
    orderBy?: string;
  };

  export type Redirect = {
    status: 302 | 401;
    body: {
      result: boolean;
      message: string;
      redirect: string;
    }
  }

  export type NotFound = {
    status: 404,
    body: {
      message?: string
    }
  }
}

export type ReqData<T,H> = {
  data: H;
} & T;

export type TOption = {
  value: string | number;
  label: string;
}